import Vue from 'vue'
import Router from 'vue-router'
import Digitalfactorydata from '@/components/Digitalfactorydata'
import DataCenter from '@/components/DataCenter'
import DataCenter_1 from '@/components/DataCenter_1'
import DataCenter_2 from '@/components/DataCenter_2'
import DataCenter_huaibin from '@/components/DataCenter_huaibin'
import DataCenter_huaibin_big from '@/components/DataCenter_huaibin_big'
import DataCenter_dark from '@/components/DataCenter_dark'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Digitalfactorydata',
      component: Digitalfactorydata
      // 正经接口数据 工业互联网
    },
    {
      path: '/datacenter',
      name: 'DataCenter',
      component: DataCenter
      // 常州大屏演示 2048*7296
    },
    {
      path: '/datacenter_huaibin',
      name: 'datacenter_huaibin',
      component: DataCenter_huaibin
      // 测试显示用
    },
    {
      path: '/datacenter_huaibin_big',
      name: 'datacenter_huaibin_big',
      component: DataCenter_huaibin_big
      // 测试显示用
    },


    {
      path: '/datacenter_1',
      name: 'DataCenter_1',
      component: DataCenter_1
      // 常州大屏_高  30s刷新
    },
    {
      path: '/datacenter_2',
      name: 'DataCenter_2',
      component: DataCenter_2
      // 常州大屏  30s刷新
    },
    {
      path: '/datacenter_2019',
      name: 'datacenter_2019',
      component: DataCenter_2
      // 常州大屏  19年版本 2048*7296
    },
    {
      path: '/datacenter_dark',
      name: 'DataCenter_dark',
      component: DataCenter_dark
      // 常州大屏 原 深色系 小尺寸
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js